import { render } from "./warranty.vue?vue&type=template&id=47ed514a"
import script from "./warranty.vue?vue&type=script&setup=true&lang=js"
export * from "./warranty.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/warranty/warranty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47ed514a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47ed514a', __exports__)) {
    api.reload('47ed514a', __exports__)
  }
  
  module.hot.accept("./warranty.vue?vue&type=template&id=47ed514a", () => {
    api.rerender('47ed514a', render)
  })

}


export default __exports__